import React from 'react'
import {  useState,useContext,useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALL_COMPETENCE_EVALUATION } from '../../Querys/querys';
import EliminaCompetenceEvaluation from "./modals/EliminaCompetencePerformanceEvaluation";
import { Grid } from "@material-ui/core";
import {Box} from '@mui/material';
import { createCompetenceEvaluationModal  } from "../../context/PerformanceEvaluationContext/Actions";
import PerformanceEvaluationContext from "../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import SearcherTableCompetenceEvaluation from "./Components/SearcherTableCompetenceEvaluation";
import BtnCreateCompetenceEvaluation from "./Components/BtnCreateCompetenceEvaluation";
import TableCompetenceEvaluation from "./Components/TableCompetenceEvaluation";
import ModalCreateCompetenceEvaluation from "./modals/ModalCreateCompetenceEvaluation";
import "./css/CompetencePerformance.css";

const CompetencePerformanceEvaluation = () => {
    const { dispatch } = useContext(PerformanceEvaluationContext);
    const [page, setPage] = useState(0);    
    const [selected, setSelected] = useState<readonly number[]>([]);
    const [ setArrayCompetenceEvaluation] = useState([])
    const [competenceEvaluation, setCompetenceEvaluation] = useState([])
    const [CompetenceEvaluationInit, setCompetenceEvaluationInit] = useState([])
    const [CompetenceEvaluationFilter, setCompetenceEvaluationFilter] =  useState([])
    const {data,loading, startPolling, stopPolling} = useQuery(GET_ALL_COMPETENCE_EVALUATION);
    const allCompetence = data?.GET_ALL_COMPETENCE_EVALUATION;
    
    useEffect(() => {
      startPolling(10000);
      return () =>{
      stopPolling()
      }
    }, [allCompetence,startPolling, stopPolling]); 

    useEffect(() => {
      if(data?.GET_ALL_COMPETENCE_EVALUATION){        
      if (allCompetence.length > 0 ) {
        setCompetenceEvaluation(allCompetence) 
        setCompetenceEvaluationInit(allCompetence) 
        setCompetenceEvaluationFilter(allCompetence)   
      }else{
        setCompetenceEvaluation([]) 
        setCompetenceEvaluationInit([]) 
        setCompetenceEvaluationFilter([])   
      }
    }
    }, [allCompetence, data?.GET_ALL_COMPETENCE_EVALUATION]);

    useEffect(() => {    
      
        const ordreFilter=[...CompetenceEvaluationFilter]
              ordreFilter.sort((a:any, b:any)=>{ return (b.id- a.id)})
              setCompetenceEvaluation(ordreFilter);    
              setPage(0)
      
  }, [CompetenceEvaluationFilter]);

      
  const createModal = () => {
    createCompetenceEvaluationModal({ _id: '0', modalCompetenceEvaluation: true }, dispatch);
  };
   

  return (
    <>  
    <div className="c_contenedorPrincipal">
    <Box display="flex" flexDirection="column" p={4}>
    <Grid container className="screenBtns">
    <div className='surveyTitle'>Competencias</div>
    <BtnCreateCompetenceEvaluation 
              txtBtn="Crear competencia" 
              openModal={createModal}
              />
    </Grid>   
    {(loading === true) ?
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
    :<>
    <Box pb={3} pt={1}>
    <SearcherTableCompetenceEvaluation 
              initState={competenceEvaluation}
              setState={setCompetenceEvaluationFilter}   
              stateInitial={CompetenceEvaluationInit}                      
              label={"Buscar competencia"}
              fields={['nameCompetence']}
              width={300}
            /> 
    </Box>  
          {
            CompetenceEvaluationInit.length > 0 ? (
              <TableCompetenceEvaluation
              rows={competenceEvaluation}
              setArrayCompetenceEvaluation={setArrayCompetenceEvaluation}
              selected={selected}
              setSelected={setSelected}
              page={page}
              setPage={setPage}
             />
            ):
              <div className="contenedorMensajeCarga">
                  <div className="mensajeCarga"> Comienza a crear Competencias</div>
              </div>
          }
      </>
       } 
      </Box>
        <ModalCreateCompetenceEvaluation/>
        <EliminaCompetenceEvaluation />
    </div>
    </>   
  )
}

export default CompetencePerformanceEvaluation